import React from 'react';
import PropTypes from 'prop-types';

// components
import FiltersPopupMobileTop from '@/kenwood/components/molecules/FiltersPopupMobileTop';
import FiltersPopupMobileContent from '@/kenwood/components/molecules/FiltersPopupMobileContent';
import FiltersPopupMobileBottom from '@/kenwood/components/molecules/FiltersPopupMobileBottom';

const FiltersPopupMobile = ({
  areMobileFiltersOpen,
  filtersData,
  filterLabel,
  clearFiltersLabel,
  applyLabel,
  sortByLabel,
  onClose,
  onClearFilters,
  onApplyFilter,
  onApplySort,
}) => {
  const hasAppliedFilters = filtersData?.breadcrumbs?.length > 0;
  const facets = filtersData?.facets || [];
  const sorts = filtersData?.sorts || [];
  return (
    <section
      className={`ken-plp__filters__mobile-popup ${
        areMobileFiltersOpen ? ' --open' : ''
      }`}
    >
      <FiltersPopupMobileTop
        hasAppliedFilters={hasAppliedFilters}
        filterLabel={filterLabel}
        clearFiltersLabel={clearFiltersLabel}
        onClearFilters={onClearFilters}
        onClose={onClose}
      />
      <FiltersPopupMobileContent
        areMobileFiltersOpen={areMobileFiltersOpen}
        facets={facets}
        sorts={sorts}
        sortByLabel={sortByLabel}
        onApplyFilter={onApplyFilter}
        onApplySort={onApplySort}
      />
      <FiltersPopupMobileBottom applyLabel={applyLabel} onClose={onClose} />
    </section>
  );
};

FiltersPopupMobile.propTypes = {
  areMobileFiltersOpen: PropTypes.bool,
  filtersData: PropTypes.shape(),
  filterLabel: PropTypes.string,
  clearFiltersLabel: PropTypes.string,
  applyLabel: PropTypes.string,
  sortByLabel: PropTypes.string,
  onClose: PropTypes.func,
  onClearFilters: PropTypes.func,
  onApplyFilter: PropTypes.func,
  onApplySort: PropTypes.func,
};

FiltersPopupMobile.defaultProps = {
  areMobileFiltersOpen: false,
  filtersData: null,
  filterLabel: 'Filters',
  clearFiltersLabel: 'Clear all',
  applyLabel: 'APPLY',
  sortByLabel: 'Sort by',
  onClose: null,
  onClearFilters: null,
  onApplyFilter: null,
  onApplySort: null,
};

export default FiltersPopupMobile;
